import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import TranslationsKeys from '../../../TranslationsKeys';

/**
 * Success confirmation card shown after workshop registration submission.
 */
export default function WorkshopRegistrationSuccess({ submittedName }) {
    const { translate } = useTranslate();

    const successMessageTemplate = translate(
        TranslationsKeys.REGISTRATION_SUCCESS_MESSAGE,
        'Thank you {0} for registering for the Saddle Making Workshop.'
    );

    const renderSuccessMessage = () => {
        const parts = successMessageTemplate.split(/\{0\}|\{name\}/);
        if (parts.length > 1) {
            return (
                <>
                    {parts[0]}
                    {submittedName ? <strong>{submittedName}</strong> : ''}
                    {parts[1]}
                </>
            );
        }
        return successMessageTemplate;
    };

    return (
        <div className="p-main bg-white border-15 p-4 p-md-5 text-center mb-main">
            <div className="d-flex justify-content-center align-items-center mb-4">
                <i
                    className="fa-solid fa-circle-check text-success w-unset"
                    style={{ fontSize: 72, lineHeight: 1 }}
                    aria-hidden="true"
                ></i>
            </div>

            <h3 className="fw-bold mb-3 text-success">
                {translate(
                    TranslationsKeys.REGISTRATION_SUCCESSFUL,
                    'Registration Successfully!'
                )}
            </h3>

            <p className="text-muted mb-4" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                {renderSuccessMessage()}
            </p>
        </div>
    );
}
